export default __webpack_public_path__ + "static/media/gump-logo.f3c55db9.svg";